import api from "core/api/api";
import { getParams } from "../../../../../../../../../src/modules/wizards/services";

export default {
    wizardType: "OJET",

    getJDBCURL: m => {
        if (m.get("supportDownStreamCapture")) {
            return (
                "jdbc:oracle:thin:@//" +
                m.get("primaryDatabaseHostname") +
                ":" +
                m.get("primaryDatabasePort") +
                "/" +
                m.get("serviceName")
            );
        }
        return "jdbc:oracle:thin:@//" + m.get("host") + ":" + m.get("port") + "/" + m.get("sid");
    },

    getConnectionParams: async (type, model) => getParams(type, model),

    async validateConnection(model, agentName, { isCDC, checkPrimaryDatabase, metaObjectFQN, adapterName_version }) {
        let wizardURL = model.getJDBCURL();
        const sslParams = await getParams("OJET", model, !!checkPrimaryDatabase);
        if (sslParams?.ConnectionURL) wizardURL = sslParams.ConnectionURL;
        const sslConfigMap = sslParams?.sslConfigMap ?? null;
        const sslConfigString = model.get("SSLConfig");

        const username = checkPrimaryDatabase ? model.get("primaryDatabaseUsername") : model.get("username");
        let password = checkPrimaryDatabase ? model.get("primaryDatabasePassword") : model.get("password");

        if (model.get("encrypted") && password !== "object") {
            password = { encrypted: password };
        }
        const useConnectionProfile = model.get("useConnectionProfile");
        const connectionProfileName = checkPrimaryDatabase
            ? model.get("primaryConnectionProfileName")
            : model.get("connectionProfileName");
        const params = {
            UserName: username,
            Password: password,
            ConnectionURL: wizardURL,
            useConnectionProfile,
            connectionProfileName,
            ...(sslConfigMap && { sslConfigMap }),
            ...(sslConfigString && { SSLConfig: sslConfigString })
        };

        const data = await api
            .WizardHelper_ValidateConnection("OJET", params, agentName, metaObjectFQN, adapterName_version)
            .catch(e => {
                console.log(e);
                throw e;
            });
        if (data.result === true) return data;
        throw data;
    },
    isDownstreamInfoFilled(model) {
        const connectionInfoFilled =
            (model.get("supportDownStreamCapture") &&
                model.get("primaryDatabaseUsername") &&
                model.get("primaryDatabasePassword") &&
                model.get("primaryDatabaseHostname") &&
                model.get("primaryDatabaseServiceName") &&
                model.get("primaryDatabasePort")) ||
            model.get("primaryConnectionProfileName");
        return connectionInfoFilled || false;
    },

    async fetchTableWrapper(model, agentName, metaObjectFQN, adapterName_version) {
        let params = await getParams(
            "OJET",
            model,
            model?.isDownstreamInfoFilled?.() ?? this.isDownstreamInfoFilled(model)
        );
        if (model.get("encrypted") && params.Password && typeof params.Password !== "object") {
            params.Password = { encrypted: params.Password };
        }
        return api.WizardHelper_GetDBs("OJET", params, agentName, metaObjectFQN, adapterName_version);
    }
};
